// extracted by mini-css-extract-plugin
export default {"newsPage":"NewsPage_newsPage__lHET4"};